import _ from 'lodash';
import Papa from 'papaparse';
const langUrl = '/i18n/{lang}.translation.csv';

export async function fetchTranslations(lang: string) {
	return new Promise((resolve) => {
		const csv = langUrl.replace('{lang}', lang);
		Papa.parse(csv, {
			header: true,
			download: true,
			complete: (response: any) => {
				const obj: any = {};
				if (_.isArray(response.data)) {
					response.data.forEach((row: any) => {
						obj[row.key] = row;
					});
				}
				resolve(obj);
			},
		});
	});
}
